module.exports = __webpack_public_path__ + "img/koniec@tab.afca5303.webp";